import { BiBorderRadius } from "react-icons/bi";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "60%",
      rows: {
        row1: [
          {
            name: "importEximScheme",
            label: "Exim Scheme",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            options: [
              {
                label: "GSTIN of Normal Person /Individual IEC",
                value: "GSTIN of Normal Person /Individual IEC",
              },
            ]
            // disabled: true,
          },
        ],
        row2: [
          {
            name: "importSchemeNotn",
            label: "Scheme Notn",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            options: [
              {
                label: "0523",
                value: "0456",
              },
            ]
            //disabled: true,
          },
          {
            name: "importSchemeNotnNumber",
            // disabled:true,
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            options: [
              {
                label: "C11",
                value: "C22",
              },
            ]

          },
          {
            name: "importSchemeNotnDescription",
            // disabled: true,
            component: "text-field",
          },
        ],
        row3: [
          {
            name: "importPolicyParaYear",
            label: "Policy Para/Year",
            component: "text-field",
            // disabled:true
          },

          {
            name: "importPolicyParaYearValue",
            component: "text-field",
            // disabled:true

          },
        ],

        row4: [
          {
            name: "importAccessoryText",
            actionText: "Generic Desc",
            component: "textarea",
            // disabled:true,
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],
        row5: [
          {
            name: "importAccessories",
            label: "Accessories",
            component: "dropdown",
            width:30,
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            options: [
              {
                label: "GSTIN of Normal Person /Individual IEC",
                value: "GSTIN of Normal Person /Individual IEC",
              },
            ],
           
          },
          {
            name: "importAccessoryUnitCode",
            label: "Unit Code",
            component: "text-field",
            width:30,
          },
        ],
        row6: [
          {
            name: "importGenericDescription",
            // disabled: true,
            component: "textarea",
            sx: {
              height: "10%",
              borderRadius: 10,
            },
          },
        ],
        row7: [
          {
            name: "importAlternateQty",
            label: "Alternate Qty1",
            component: "text-field",
            dataType: "int",
            //  disabled:true
          },
          {
            name: "importAlternateQtyUnit",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getQuantity"
            // disabled:true

          },
        ],
        row8: [
          {
            name: "importAlternateQtyOther",
            label: "Alternate Qty2",
            component: "text-field",
            dataType: "int"

          },
          {
            name: "importAlternateQtyOtherUnit",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getQuantity"
          },
        ],
      },
    },
  ]
};
